import { action, computed, observable } from 'mobx';
import { query, serviceQueries } from '@estee/elc-service-bus';

enum Status {
    IDLE = 'IDLE',
    LOADING = 'LOADING',
    ERROR = 'ERROR',
    LOADED = 'LOADED'
}

export class AuthenticatedRepository {
    private initialPromise: Promise<void>;
    @observable private status: Status = Status.IDLE;

    @observable
    private isAuthenticated: boolean = false;

    @action public ensureData() {
        if (this.isUnfulfilled) {
            this.initialPromise = this.loadData();
        }

        return this.initialPromise;
    }

    @action private async loadData() {
        try {
            this.status = Status.LOADING;
            this.isAuthenticated = (await query(serviceQueries.IS_AUTHENTICATED)) as boolean;

            if (this.isAuthenticated) {
                await this.fetchData();
                this.status = Status.LOADED;
            }
        } catch (err) {
            this.status = Status.ERROR;
        }
    }

    @action public async fetchData() {}

    @computed public get isUnfulfilled() {
        return [Status.IDLE, Status.ERROR].includes(this.status);
    }
}
